import { Organization } from '../model/organization';
import { Event } from '../model/event';
import { GeoCoordinates } from './geo-coordinates';
import { compareByDistanceKm } from './geo-distance';
import { organizationCoordinates } from './map-markers';
import { SortCompare } from './editable-first';

export function compareOrganizationsByDistance(
  user: GeoCoordinates | null | undefined,
  events: readonly Event[],
): SortCompare<Organization> {
  return (first, second) => {
    if (user) {
      const firstCoords = organizationCoordinates(first.id, events);
      const secondCoords = organizationCoordinates(second.id, events);
      const distDiff = compareByDistanceKm(user, firstCoords, secondCoords);
      if (distDiff !== 0 && !Number.isNaN(distDiff)) {
        return distDiff;
      }
    }
    return (second.id ?? 0) - (first.id ?? 0);
  };
}
